import { Dialog, DialogContent, DialogTitle, Typography } from '@mui/material';
import { useTranslation } from '../hooks/useTranslation';
import PrimaryButton from './PrimaryButton';

const Under18Dialog = (props) => {
  const { isOpen, setIsOpen } = props;
  const { t } = useTranslation();

  return (
    <Dialog
      open={isOpen}
      onOpenChange={setIsOpen}
      PaperProps={{ sx: { borderRadius: '10px' } }}
    >
      <DialogContent sx={{ padding: '16px' }}>
        <div
          style={{
            marginInline: 'auto',
            width: '75px',
            height: '75px',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="76"
            height="75"
            viewBox="0 0 76 75"
            fill="none"
          >
            <circle cx="37.9987" cy="37.4992" r="34.7248" fill="white" />
            <path
              d="M47.2942 50.2523C44.0796 50.2523 41.5539 49.6023 39.717 48.3024C37.9057 47.0024 37 45.2089 37 42.9219C37 41.1164 37.574 39.6239 38.7221 38.4443C39.8701 37.2647 41.3498 36.5666 43.1612 36.3499V37.2888C41.5284 36.9517 40.2018 36.2175 39.1813 35.0861C38.1863 33.9305 37.6888 32.5463 37.6888 30.9334C37.6888 28.7668 38.5435 27.0696 40.2528 25.8419C41.9876 24.6141 44.3348 24.0002 47.2942 24.0002C50.2791 24.0002 52.6262 24.6141 54.3355 25.8419C56.0449 27.0696 56.8995 28.7668 56.8995 30.9334C56.8995 32.5704 56.4148 33.9666 55.4453 35.1222C54.5014 36.2777 53.2385 36.9758 51.6568 37.2165V36.3499C53.4171 36.5906 54.8458 37.3008 55.9428 38.4804C57.0653 39.66 57.6266 41.1405 57.6266 42.9219C57.6266 45.2089 56.7082 47.0024 54.8713 48.3024C53.0599 49.6023 50.5342 50.2523 47.2942 50.2523ZM47.2942 45.9552C48.927 45.9552 50.1388 45.6663 50.9297 45.0886C51.746 44.5108 52.1542 43.6562 52.1542 42.5247C52.1542 41.3933 51.746 40.5507 50.9297 39.997C50.1388 39.4193 48.927 39.1304 47.2942 39.1304C45.6869 39.1304 44.4751 39.4193 43.6587 39.997C42.8423 40.5507 42.4341 41.3933 42.4341 42.5247C42.4341 43.6562 42.8423 44.5108 43.6587 45.0886C44.4751 45.6663 45.6869 45.9552 47.2942 45.9552ZM47.2942 34.8333C48.6463 34.8333 49.6796 34.5444 50.3939 33.9666C51.1082 33.3648 51.4654 32.5583 51.4654 31.5473C51.4654 30.5362 51.1082 29.7418 50.3939 29.164C49.6796 28.5862 48.6463 28.2973 47.2942 28.2973C45.9675 28.2973 44.947 28.5862 44.2327 29.164C43.5184 29.7418 43.1612 30.5362 43.1612 31.5473C43.1612 32.5583 43.5184 33.3648 44.2327 33.9666C44.947 34.5444 45.9675 34.8333 47.2942 34.8333Z"
              fill="black"
            />
            <path
              d="M20.1232 50.2521V45.4857H25.9176V28.8408H28.5613L20.7388 33.5327V28.0961L27.5473 24H31.5672V45.4857H36.9995V50.2521H20.1232Z"
              fill="black"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M63.9377 64.5851C64.2933 64.2445 64.6421 63.897 64.9841 63.5428C65.6282 62.8755 66.2478 62.1844 66.8414 61.471C72.2493 54.9715 75.5018 46.6152 75.5018 37.4991C75.5018 16.7869 58.7113 -0.00366211 37.999 -0.00366211C28.935 -0.00366211 20.622 3.21187 14.1386 8.56443C13.4228 9.15532 12.7294 9.77225 12.0597 10.4138C11.7046 10.754 11.3561 11.1011 11.0146 11.4549C10.7128 11.7675 10.4164 12.0854 10.1255 12.4083C4.13955 19.0538 0.496216 27.851 0.496216 37.4991C0.496216 58.2114 17.2868 75.002 37.999 75.002C47.5951 75.002 56.3494 71.3978 62.9821 65.4693C63.3058 65.1801 63.6243 64.8853 63.9377 64.5851ZM14.0532 16.3513C9.06926 21.9889 6.05219 29.3879 6.05219 37.4991C6.05219 55.1429 20.3553 69.446 37.999 69.446C46.0661 69.446 53.4285 66.4617 59.0544 61.5264L14.0532 16.3513ZM18.0797 12.5208L62.9003 57.5146C67.3115 52.0354 69.9459 45.0794 69.9459 37.4991C69.9459 19.8554 55.6428 5.55231 37.999 5.55231C30.4629 5.55231 23.544 8.15602 18.0797 12.5208Z"
              fill="#00D1D2"
            />
          </svg>
        </div>
        <DialogTitle
          sx={{ marginTop: '16px', padding: 0, textAlign: 'center' }}
          fontSize={'18px'}
          fontWeight={'700'}
        >
          {t('dobPage.over18.title')}
        </DialogTitle>
        <Typography
          sx={{ marginTop: '12px', textAlign: 'center', padding: 0 }}
          fontSize={'13px'}
          fontWeight={'500'}
        >
          {t('dobPage.over18.description')}
        </Typography>
        <PrimaryButton
          onClick={() => setIsOpen(false)}
          sx={{ marginTop: '16px' }}
        >
          {' '}
          {t('close')}
        </PrimaryButton>
      </DialogContent>
    </Dialog>
  );
};

export default Under18Dialog;
